import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import useFetch from '../../common/useFetch';
import PrizeSchemeService from '../../domain/PrizeSchemeService';
import gs from '../../styles/style';
import Breadcrumbs from '../Common/Breadcrumbs';
import { useForm } from '../Common/Form';
import Loader from '../Common/Loader';
import PrizeSchemeForm from './PrizeSchemeForm';
var EditPrizeSchemeForm = function (_a) {
    var history = _a.history, match = _a.match;
    var t = useTranslation()[0];
    var form = useForm({
        values: {
            prizes: []
        },
        onSubmit: function (data) { return PrizeSchemeService.editPrizeScheme(data); },
        onSuccess: function (prizeScheme) { return history.push("/prize-schemes/".concat(prizeScheme.id)); }
    });
    var _b = useFetch(function (config) { return PrizeSchemeService.getPrizeScheme(match.params.prizeScheme, config); }, {
        onSuccess: function (prizeScheme) {
            if (prizeScheme.prizes.length == 0) {
                prizeScheme.prizes.push({});
            }
            form.initValues(prizeScheme);
            setLoading(false);
        }
    }), prizeScheme = _b.data, getPrizeScheme = _b.get;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        getPrizeScheme();
    }, []);
    if (loading) {
        return React.createElement(Loader, null);
    }
    return React.createElement("div", null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/prize-schemes" }, t('prize_schemes')),
            t('edit_prize_scheme')),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, prizeScheme.title)),
        React.createElement(PrizeSchemeForm, { form: form }));
};
export default withRouter(EditPrizeSchemeForm);
